export var VERSION = "1.4.1";
//# sourceMappingURL=version.js.map